import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../utils/utils";

// Action: Fetch receipt list
export const get_receipt_list = createAsyncThunk(
  "receipts/list",
  async (data) => {
    const body = new FormData();
    // body.append("userid", data.userid); //
    body.append("page", data.page);
    body.append("limit", data.limit);
    body.append("action", "list");

    const response = await fetch(baseUrl + "receipt.php", {
      method: "POST",
      body: body,
    });
    const res = await response.json();
    return res;
  }
);
export const delete_receipt = createAsyncThunk(
  "receipts/delete",
  async (id) => {
    const body = new FormData();
    body.append("action", "delete");
    body.append("id", id);

    const response = await fetch(baseUrl + "receipt.php", {
      method: "POST",
      body: body,
    });
    const res = await response.json();
    return res;
  }
);
export const add_receeipt = createAsyncThunk(
  "receipts/create",
  async (data) => {
    const body = new FormData();
    body.append("action", "create");
    body.append("userid", data.userid);
    body.append("voucher_date", data.voucher_date);
    body.append("amount", data.amount);
    body.append("payment_mode", data.payment_mode);
    body.append("transaction_number", data.transaction_number);
    body.append("mode_of_transaction", data.mode_of_transaction);
    body.append("narration", data.narration);
    if (Array.isArray(data.orderid)) {
      data.orderid.forEach((id) => body.append("orderid[]", id));
    } else {
      body.append("orderid[]", data.orderid);
    }
    const response = await fetch(baseUrl + "receipt.php", {
      method: "POST",
      body: body,
    });
    const res = await response.json();
    return res;
  }

)
const receiptSlice = createSlice({
  name: "receipt",
  initialState: {
    receipt_list: [],
    total_receipt_count: 0,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(get_receipt_list.fulfilled, (state, action) => {
      if (action.payload.success) {
        state.receipt_list = action.payload.data;
        state.total_receipt_count = action.payload.totalcount;
      }
    });
    builder.addCase(delete_receipt.fulfilled, (state, action) => {
      if (action.payload.success) {
        state.receipt_list = state.receipt_list.filter(
          (receipt) => receipt.id !== action.meta.arg
        );
        state.total_receipt_count -= 1;
      }
    });
    builder.addCase(add_receeipt.fulfilled, (state, action) => {
      if( action.payload.success) {
        state.receipt_list.push(action.payload.data);
        state.total_receipt_count += 1;
      }
    })
  },
});

export default receiptSlice.reducer;
